import { buildHref } from "@softmax/web-addresses";
import { NavigationReady } from "@softmax/web-features/navigation/markers";
import { AccountFrame } from "@softmax/product-ux/account";
import { AccountSettings } from "./settings/account-settings";
import { AccountSavedMaps } from "./settings/account-saved-maps";
import { AccountSignOut } from "./settings/account-sign-out";
import { AccountUsage } from "./usage/account-usage";
import type { AccountPageData } from "./account.types";
import { VerifiedSession } from "@/session/product-session";

import { ProfileAccountContent } from "./profile/profile-account-content";

export function AccountPage({ data }: { data: AccountPageData }) {
  return (
    <VerifiedSession sessionUserId={data.sessionUserId}>
      <AccountContent data={data} />
    </VerifiedSession>
  );
}

function AccountContent({ data }: { data: AccountPageData }) {
  if (data.kind === "profile") {
    return <ProfileAccountContent data={data} />;
  }

  return (
    <AccountFrame
      title="Account settings"
      description="Manage your profile, preferences, and linked accounts."
      section="settings"
      settingsHref={buildHref({ name: "account" })}
      credentialsHref={buildHref({ name: "accountCredentials" })}
    >
      <NavigationReady
        stage="content"
        path={buildHref({ name: "account" })}
        hydrated
      />
      <AccountSettings {...data.account} />
      <AccountUsage />
      <AccountSavedMaps />
      <AccountSignOut />
    </AccountFrame>
  );
}
